import axios from 'axios';
import { TokenUtils } from '@/utils/TokenUtils';

const baseUrl = `${process.env.VUE_APP_BASEURL}`;
const baseCfdiUrl = `${process.env.VUE_APP_BASECFDIURL}`;
const baseUrlAlmacen = process.env.VUE_APP_BASEURL_ALMACEN;

export default axios.create({
  baseURL: baseUrl,
});

export const cfdiAxios = axios.create({
  baseURL: baseCfdiUrl,
});

export const almacenAxios = axios.create({
  baseURL: baseUrlAlmacen,
  headers: { 'Content-Type': 'application/json' },
});

const addAuth = (instance) => {
  instance.interceptors.request.use((config) => {
    const newConfig = config;
    const token = TokenUtils.getToken();
    if (token) {
      newConfig.headers.Authorization = `Bearer ${token}`;
    }
    return newConfig;
  });

  instance.interceptors.response.use(
    (response) => response,

    (error) => {
      // Verificamos si el backend rechazó la petición por problemas de autenticación
      if (error.response && (error.response.status === 401 || error.response.status === 403)) {
        window.location.href = '/login';
      }
      // Retornamos el error para que la pantalla que hizo la petición también se entere
      return Promise.reject(error);
    },
  );
};

addAuth(almacenAxios);
